import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BannerTcfDeclaration } from "./declaration.js";
import { useBanner } from "../../../../contexts/banner.js";
import { useBannerTcfDeclarations } from "../../../../hooks/banner/useBannerTcfDeclarations.js";
import { Group } from "../../../common/groups/group.js";
const BannerTcfDeclarationList = ({ declaration })=>{
    const banner = useBanner();
    const { i18n: { tcf: { declarations: { [declaration]: { title, desc } } } } } = banner;
    const declarations = useBannerTcfDeclarations(declaration);
    return declarations.length > 0 ? /*#__PURE__*/ _jsxs(Group, {
        headline: title,
        children: [
            desc,
            declarations.map(({ id })=>/*#__PURE__*/ _jsx(BannerTcfDeclaration, {
                    declaration: declaration,
                    id: id
                }, id))
        ]
    }) : null;
};
export { BannerTcfDeclarationList };
